import { FormField } from "../../shared/components/dynamic-form/dynamic-form.interface";

export const CHANGE_PASSWORD_FORM: FormField[] = [
  {
    key: 'password',
    label: 'Contraseña',
    type: 'password',
    required: true,
  },
  {
    key: 'confirm_password',
    label: 'Confirmar Contraseña',
    type: 'password',
    required: true,
  },
]

export const BASIC_USER_FORM: FormField[] = [
  {
    key: 'name',
    label: 'Nombre',
    type: 'text',
    required: true,
    minLength: 3,
    maxLength: 50,
  },
  {
    key: 'first_surname',
    label: 'Primer Apellido',
    type: 'text',
    required: true,
    minLength: 3,
    maxLength: 50,
  },
  {
    key: 'second_surname',
    label: 'Segundo Apellido',
    type: 'text',
    minLength: 3,
    maxLength: 50,
  },
  {
    key: 'cellphone',
    label: 'Celular',
    type: 'text',
    required: true,
    minLength: 8,
  },
]

export const USER_CONSUMER_FORM: FormField[] = [
  ...BASIC_USER_FORM,
];

export const USER_ADVISOR_FORM: FormField[] = [
  ...BASIC_USER_FORM,
  // {
  //   key: 'ci',
  //   label: 'Cédula de Identidad',
  //   type: 'number',
  //   required: true,
  // },
];
  
export const USER_SPONSOR_FORM: FormField[] = [
  // {
  //   key: 'title',
  //   label: 'Denominación de la Empresa',
  //   type: 'text',
  //   required: true,
  // },
  {
    key: 'name',
    label: 'Nombre(s) de la Persona de Contacto',
    type: 'text',
    required: true,
    minLength: 3,
    maxLength: 50,
  },
  {
    key: 'first_surname',
    label: 'Apellido Paterno de la Persona de Contacto',
    type: 'text',
    required: true,
    minLength: 3,
    maxLength: 50,
  },
  {
    key: 'second_surname',
    label: 'Apellido Materno de la Persona de Contacto',
    type: 'text',
    minLength: 3,
    maxLength: 50,
  },
  {
    key: 'ci',
    label: 'NIT',
    type: 'number',
    minLength: 6,
    required: true,
  },
  {
    key: 'cellphone',
    label: 'Celular Institucional',
    type: 'text',
    required: true,
    minLength: 8,
  },  
];


export const CONSUMER_FORM: FormField[] = [
  {
    key: 'business_name',
    label: 'Nombre de la empresa',
    type: 'text',
    required: true,
    minLength: 2,
    maxLength: 200,
  },
  {
    key: 'business_rol',
    label: 'Rol en la empresa',
    type: 'select',
    required: true,
    catalog: 'business-rol',
    options: [],
  },
  {
    key: 'cities',
    label: 'Ciudad de Residencia',
    type: 'select',
    required: true,
    catalog: 'cities',
    options: [],
    colSpan: 2,
  },
  {
    key: 'consumer_address',
    label: 'Ubicación',
    type: 'text',
    // required: true,
    minLength: 5,
    maxLength: 1000,
    colSpan: 2,
  },
  {
    key: 'consumer_gender',
    label: 'Género',
    type: 'select',
    required: true,
    catalog: 'genders',
    options: [],
    colSpan: 2,
  },

  {
    key: 'business_time',
    label: '¿Hace cuánto tiempo existe tu empresa/emprendimiento?',
    type: 'select',
    colSpan: 2,
    catalog: 'business_time',
    options: [],
    required: true,
  },
  {
    key: 'principal_activity',
    label: '¿Cuál es la actividad principal de tu empresa/emprendimiento?',
    type: 'textarea',
    colSpan: 2,
    rows: 4,
    minLength: 10,
    maxLength: 1500,
    required: true,
    //
  },
  {
    key: 'team_size',
    label: '¿De qué tamaño es tu equipo actualmente?',
    type: 'select',
    colSpan: 2,
    catalog: 'team_size',
    options: [],
    required: true,
  },
  // generate fields for all questions
  {
    key: 'sales_month',
    label: '¿Cuál es el nivel aproximado de tus ventas mensuales?',
    type: 'select',
    required: true,
    catalog: 'sales_month',
    options: [],
    colSpan: 2,
  },
  {
    key: 'revenue_stream',
    label: '¿Cómo definirías tu flujo de ingresos?',
    type: 'select',
    required: true,
    catalog: 'revenue_stream',
    options: [],
    colSpan: 2,
  },
  {
    key: 'has_salary',
    label: '¿Te pagas un sueldo regularmente?',
    type: 'select',
    required: true,
    catalog: 'has_salary',
    options: [],
    colSpan: 2,
  },
  {
    key: 'has_information_registry',
    label: '¿Llevas registro de tu información?',
    type: 'multiselect',
    required: true,
    catalog: 'has_information_registry',
    options: [],
    colSpan: 2,
  },
  // ¿Cuál es tu nivel de organización contable ? Select	Obligatorio
  {
    key: 'accounting_level',
    label: '¿Cuál es tu nivel de organización contable?',
    type: 'select',
    required: true,
    catalog: 'accounting_level',
    options: [],
    colSpan: 2,
  },
  // ¿De qué manera registras la información ? Select	Obligatorio
  {
    key: 'information_registry_type',
    label: '¿De qué manera registras la información?',
    type: 'select',
    required: true,
    catalog: 'information_registry_type',
    // Sistema contable/ERP · Excel/hojas de cálculo · Cuaderno/notas · No registro información
    options: [],
    colSpan: 2,
  },
  // ¿Cuál es el principal problema que necesitas resolver hoy ? Texto	obligatorio
  {
    key: 'principal_problem',
    label: '¿Cuál es el principal problema que necesitas resolver hoy?',
    type: 'textarea',
    rows: 4,
    required: true,
    minLength: 10,
    maxLength: 1500,
    colSpan: 2,
  },
  // ¿Cuál es el área que consideras más desorganizada en tu empresa / emprendimiento ? Select	Obligatorio
  {
    key: 'unorganized_area',
    label: '¿Cuál es el área que consideras más desorganizada en tu empresa / emprendimiento?',
    type: 'select',
    required: true,
    catalog: 'unorganized_area',
    options: [],
    colSpan: 2,
  },
  // ¿Qué crees que te impide crecer actualmente ? Multi - select	Obligatorio
  {
    key: 'reason_prevent_growth',
    label: '¿Qué crees que te impide crecer actualmente?',
    type: 'multiselect',
    required: true,
    catalog: 'reason_prevent_growth',
    options: [],
    colSpan: 2,
  },
  // ¿Cuál es el nivel de urgencia que tienes para resolver esta situación ? Escala 1–5	Obligatorio
  {
    key: 'level_urgency',
    label: '¿Cuál es el nivel de urgencia que tienes para resolver esta situación?',
    type: 'radio',
    required: true,
    // 1 Nada urgente · 2 · 3 · 4 · 5 Muy urgente
    options: [
      { value: 1, label: '1 - Nada urgente' },
      { value: 2, label: '2' },
      { value: 3, label: '3' },
      { value: 4, label: '4' },
      { value: 5, label: '5 - Muy urgente' },
    ],
    colSpan: 2,
  },
  // ¿Cuál es tu objetivo principal en los siguientes 6 meses ? Select	Obligatorio
  {
    key: 'principal_objective',
    label: '¿Cuál es tu objetivo principal en los siguientes 6 meses?',
    type: 'select',
    required: true,
    catalog: 'principal_objective',
    options: [],
    colSpan: 2,
  },
  // ¿Cuánto tiempo tienes disponible cada semana para trabajar en estos problemas ? Select	Obligatorio
  {
    key: 'available_time',
    label: '¿Cuánto tiempo tienes disponible cada semana para trabajar en estos problemas?',
    type: 'select',
    required: true,
    catalog: 'available_time',
    options: [],
    colSpan: 2,
  },
  // ¿De qué forma prefieres recibir apoyo ? Select	Obligatorio
  {
    key: 'support_preference',
    label: '¿De qué forma prefieres recibir apoyo?',
    type: 'select',
    required: true,
    catalog: 'support_preference',
    options: [],
    colSpan: 2,
  },
  // ¿Qué tan dispuesto / a estás a recibir acompañamiento profesional ? Escala 1–5	Obligatorio
  {
    key: 'score_professional_help',
    label: '¿Qué tan dispuesto / a estás a recibir acompañamiento profesional?',
    type: 'radio',
    required: true,
    // 1 Nada abierto/a · 2 · 3 · 4 · 5 Totalmente abierto/a
    options: [
      { value: 1, label: '1 - Nada abierto/a' },
      { value: 2, label: '2' },
      { value: 3, label: '3' },
      { value: 4, label: '4' },
      { value: 5, label: '5 - Totalmente abierto/a' },
    ],
    colSpan: 2,
  },
  // ¿Qué modelo se aplica mejor a tu empresa / emprendimiento ? Select	Obligatorio
  {
    key: 'business_model',
    label: '¿Qué modelo se aplica mejor a tu empresa / emprendimiento?',
    type: 'select',
    required: true,
    catalog: 'business_model',
    options: [],
    colSpan: 2,
  },
  // ¿Cuál se acerca más a tu estructura societaria ? Select	Obligatorio
  {
    key: 'corporate_structure',
    label: '¿Cuál se acerca más a tu estructura societaria?',
    type: 'select',
    required: true,
    catalog: 'corporate_structure',
    options: [],
    colSpan: 2,
  },
  {
    key: 'company_size',
    label: '¿Cuál es el tamaño de la empresa?',
    type: 'select',
    required: true,
    catalog: 'company_size',
    options: [],
    colSpan: 2,
  },
  {
    key: 'business_support',
    label: '¿En qué área te gustaría recibir apoyo empresarial en el futuro? *',
    type: 'multiselect',
    required: true,
    catalog: 'business_support',
    options: [],
    colSpan: 2,
  },
];

export const ADVISOR_FORM: FormField[] = [
  {
    key: 'advisor_type',
    label: 'Categoría',
    type: 'select',
    required: true,
    catalog: 'advisor-types',
  },
  {
    key: 'title',
    label: 'Denominación',
    type: 'text',
    required: true,
    minLength: 2,
    maxLength: 200,
  },
  {
    key: 'advisor_biography',
    label: 'Biografía',
    type: 'textarea',
    required: true,
    minLength: 10,
    maxLength: 90000,
    colSpan: 2,
  },
  {
    key: 'advisor_expertise',
    label: 'Experiencia',
    type: 'wysiwyg',
    required: true,
    minLength: 3,
    maxLength: 90000,
    colSpan: 2,
  },
  {
    key: 'advisor_solutions',
    label: 'Solución de problemas',
    type: 'wysiwyg',
    required: true,
    minLength: 3,
    maxLength: 90000,
    colSpan: 2,
  },
  {
    key: 'advisor_certifications',
    label: 'Certificaciones',
    type: 'wysiwyg',
    minLength: 3,
    maxLength: 90000,
    required: true,
    colSpan: 2,
  },
  {
    key: 'tags',
    label: 'Etiquetas',
    type: 'multiselect',
    required: true,
    catalog: 'tags',
    withCustomOptions: true,
    optionLabel: 'title',
    optionValue: 'id',
    colSpan: 2,
  },
  {
    key: 'advisor_languages',
    label: 'Idiomas',
    type: 'textarea',
    required: false,
    minLength: 5,
    maxLength: 250,
    colSpan: 2,
  },
  {
    key: 'advisor_session_price',
    label: 'Precio por sesión',
    type: 'number',
    required: true,
    min: 1,
  },
  {
    key: 'advisor_session_price_detail',
    label: 'Detalle del precio',
    type: 'text',
    required: true,
    minLength: 1,
    maxLength: 1000,
  },
  {
    key: 'image_id',
    label: 'Foto de Perfil',
    type: 'file',
    folder: 'advisors',
    maxDimensions: '462px x 570px',
    required: true,
    colSpan: 2,
  },
  {
    key: 'advisor_anticipation',
    label: 'Días de anticipación para reserva',
    type: 'number',
    required: true,
    colSpan: 2,
    min: 3,
    max: 30,
  },
  {
    key: 'advisor_limit_date',
    label: 'Fecha límite para reserva',
    type: 'date',
    required: false,
    colSpan: 2,
  },
  {
    key: 'advisor_schedule',
    type: 'schedule',
    label: 'Horario',
    required: true,
    colSpan: 2,
  },
];


export const SUPPLIER_FORM: FormField[] = [
  {
    key: 'title',
    label: 'Nombre de la empresa',
    type: 'text',
    required: true,
    colSpan: 2,
    minLength: 2,
    maxLength: 200,
  },
  {
    key: 'supplier_services',
    label: 'Servicios ofrecidos',
    type: 'wysiwyg',
    required: true,
    colSpan: 2,
    minLength: 10,
    maxLength: 1500,
  },
  {
    key: 'supplier_category_service',
    label: 'Rubro del servicio',
    type: 'multiselect',
    catalog: 'supplier-category-service',
    options: [],
    required: true,
    colSpan: 2,
  },
  {
    key: 'supplier_category_service_other',
    label: 'Otros rubros del servicio',
    type: 'text',
    required: true,
    minLength: 3,
    maxLength: 200,
    colSpan: 2,
    showIf: { key: 'supplier_category_service', value: 'c23' },
  },
  {
    key: 'tags',
    label: 'Etiquetas',
    type: 'multiselect',
    required: true,
    catalog: 'tags',
    withCustomOptions: true,
    optionLabel: 'title',
    optionValue: 'id',
    colSpan: 2,
  },
  {
    key: 'supplier_approved',
    label: 'Aprobado por (certificación de calidad)',
    type: 'select',
    // required: true,
    options: [
      {
        value: 'general',
        label: 'General',
      },
      {
        value: 'recommended',
        label: 'Recomendado',
      },
    ],
    colSpan: 2,
  },
  {
    key: 'cities',
    label: 'Ciudad(es)',
    type: 'multiselect',
    required: true,
    catalog: 'cities',
    colSpan: 2,
  },
  {
    key: 'supplier_address',
    label: 'Ubicación Oficina Central',
    type: 'text',
    required: true,
    minLength: 5,
    maxLength: 100,
    colSpan: 2,
  },
  {
    key: 'supplier_discounts',
    label: 'Categoría de Descuento',
    type: 'multiselect',
    // required: true,
    options: [
      {
        value: 'five_percent',
        label: '5%',
      },
      {
        value: 'ten_percent',
        label: '10%',
      },
      {
        value: 'fifteen_percent',
        label: '15%',
      },
    ],
    colSpan: 2,
  },
  {
    key: 'contact_name',
    label: 'Nombre (s) y Apellido (s) de la Persona de Contacto',
    type: 'text',
    required: true,
    minLength: 5,
    maxLength: 100,
    colSpan: 2,
  },
  {
    key: 'contact_cellphone',
    label: 'Teléfono de la Persona de Contacto',
    type: 'number',
    required: true,
    minLength: 8,
    colSpan: 2,
  },
  {
    key: 'supplier_contact_email',
    label: 'Correo Electrónico de contacto',
    type: 'email',
    required: false,
    colSpan: 2,
  },
  {
    key: 'image_id',
    label: 'Logo Empresa',
    type: 'file',
    folder: 'suppliers',
    required: true,
    colSpan: 2,
  },
];

export const SPONSOR_FORM: FormField[] = [
  {
    key: 'title',
    label: 'Denominación de la Empresa',
    type: 'text',
    required: true,
    minLength: 2,
    maxLength: 200,
  },
  {
    key: 'sponsor_legal_name',
    label: 'Razon social',
    type: 'text',
    required: true,
    minLength: 5,
    maxLength: 200,
  },
  {
    key: 'image_id',
    label: 'Logo Empresa',
    type: 'file',
    folder: 'sponsors',
    required: true,
    colSpan: 2,
  },
];